function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 配置オフセット情報　モデル
 */
var OffsetInstanceModel =
/**
 * コンストラクタ
 *
 */
function OffsetInstanceModel() {
  _classCallCheck(this, OffsetInstanceModel);

  this.Title = "";
  this.OffsetX = 0;
  this.OffsetY = 0;
  this.OffsetZ = 0;
};

export { OffsetInstanceModel as default };